import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getTeacherGroupMemberNotInList: (state) => state.items,
  getTeacherGroupMemberNotInListPagination: (state) => state.pagination,
  getTeacherGroupMemberNotInListPage: (state) => state.pagination.current_page,
  getTeacherGroupMemberNotInListFilters: (state) => state.filters,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
